import timezoneIso from "./timezone-iso";

export default function (date, hours, minutes, seconds, timezone) {

  let iso = timezoneIso(date.getFullYear(),date.getMonth()+1 , date.getDate(), hours, minutes, seconds, timezone)
  
  return iso

}